import Region from "../../../../../models/Region";

class CoveragePoint {
  constructor(start, end, chr, val, logVal) {
    this.val = val;
    this.logVal = logVal;
    this.region = new Region(start, end, chr);
  }
}

export default CoveragePoint;
